import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  Container, Grid, Card, CardMedia,
  Dialog, Typography, Button, Box,
} from '@mui/material'
import Slide from 'react-reveal/Slide'
import { getHouse } from './api'

function toEmbedUrl(url) {
  if (!url) return null;
  const match = url.match(/(?:v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
}

function HouseDetail() {
  const { id } = useParams()
  const [house, setHouse] = useState(null)
  const [loading, setLoading] = useState(true)
  const [selectedImage, setSelectedImage] = useState(null)

  useEffect(() => {
    getHouse(id)
      .then(setHouse)
      .finally(() => setLoading(false))
  }, [id])

  if (loading) {
    return (
      <div style={{ padding: '80px', textAlign: 'center' }}>
        <Typography variant="h6" color="textSecondary">Loading...</Typography>
      </div>
    )
  }

  if (!house) {
    return (
      <div style={{ padding: '80px', textAlign: 'center' }}>
        <Typography variant="h6" color="textSecondary">House not found.</Typography>
      </div>
    )
  }

  return (
    <div style={{ paddingBottom: '40px' }}>
      <Container maxWidth="lg" style={{ padding: '32px 20px 16px' }}>
        <Typography variant="h4" gutterBottom>{house.name}</Typography>
        {house.location && (
          <Typography variant="subtitle1" color="textSecondary" gutterBottom>
            {house.location}
          </Typography>
        )}
        {house.description && (
          <Typography variant="body1" style={{ margin: '12px 0' }}>
            {house.description}
          </Typography>
        )}
        <Box mt={1} display="flex" gap={2} flexWrap="wrap">
          {house.zillow_url && (
            <Button
              variant="outlined"
              size="small"
              href={house.zillow_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              View on Zillow
            </Button>
          )}
        </Box>

        {/* YouTube embed */}
        {toEmbedUrl(house.youtube_url) && (
          <Box mt={3} sx={{ position: 'relative', paddingTop: '56.25%', borderRadius: 2, overflow: 'hidden' }}>
            <iframe
              src={toEmbedUrl(house.youtube_url)}
              title="House video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
            />
          </Box>
        )}
      </Container>

      <Slide left>
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            {house.images.map((img) => (
              <Grid item xs={12} sm={6} md={4} key={img.id}>
                <Card>
                  <CardMedia
                    component="img"
                    height="220"
                    image={img.url}
                    alt={img.filename}
                    onClick={() => setSelectedImage(img.url)}
                    style={{ cursor: 'pointer', objectFit: 'cover' }}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Slide>

      <Dialog open={!!selectedImage} onClose={() => setSelectedImage(null)} maxWidth="lg">
        <img src={selectedImage} alt="Selected" style={{ width: '100%', height: 'auto' }} />
      </Dialog>
    </div>
  )
}

export default HouseDetail
